import { keyframes } from "styled-components";

export const BtnHoverAnimation = (before: string, after: string) => keyframes`
  0% {
    background-color: ${before};
  }  

  100% {
    background-color: ${after};
  }
`;